import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { useTable, useSortBy } from "react-table";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as SearchNew } from "../../../assets/icons/search-svgrepo-com (1).svg";
import { ReactComponent as BrandCopyIcon } from "../../../assets/icons/BrandCopyIcon.svg";
import { ReactComponent as CopyIcon } from "../../../assets/icons/CopyIcon.svg";
import Select from "react-select";
import { Box, Modal, Pagination } from "@mui/material";
import { DatePicker, Button, Checkbox, Select as AntSelect } from "antd";

import {
  getAffiliateListV2,
  traderAffiliateRefList,
  getInfluencerReport,
  flagInfluencer,
} from "../../../utils/api/apis";
// import CircularProgress from "@mui/material/CircularProgress";
import CircularProgress from "@mui/material/CircularProgress";
import { setIsLoading } from "../../../store/reducers/authSlice";
import { returnErrors } from "../../../store/reducers/error";
import { toast } from "react-toastify";
import CopyToClipboard from "react-copy-to-clipboard";
import { formatCurrency } from "../../../utils/helpers/string";

const { RangePicker } = DatePicker;

const downloadBlob = (data, filename, type) => {
  const blob = new Blob([data], { type });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  
  // Append to body, click, and clean up
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

function AffiliateTable({ filter, activeUser, userData }) {
  const { selectedBrand } = useSelector((state) => state.brand);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [affiliateId, setAffiliateId] = useState(null);
  const navigate = useNavigate(); // Hook for navigation
  const location = useLocation(); // Hook to get current route.
  // Define route options for the dropdown
  const routeOptions = [
    { value: "/affiliate-marketing/affiliate-list", label: "Affiliate List" },
    {
      value: "/affiliate-marketing/codes-list",
      label: "Codes List",
    },
    {
      value: "/affiliate-marketing/create-codes",
      label: "Create Affiliate Code",
    },
  ];

  // Get the current route path to set the active state
  const currentRoute =
    routeOptions.find((option) => option.value === location.pathname) ||
    routeOptions[0];

  // Handle route change
  const handleRouteChange = (selectedOption) => {
    navigate(selectedOption.value);
  };
  const handleRowClick = (affiliateId, email) => {
    const url = `/affiliate-marketing/overview?affiliateId=${affiliateId}&email=${email}`;
    navigate(url);
  };
  const openModal = (id) => {
    setAffiliateId(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setModalContent(null);
    setIsModalOpen(false);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      marginTop: "4px",
      height: 48,
      borderRadius: 8,
      border: "none",
      boxShadow: "none",
      paddingRight: "20px",
      fontFamily: "DM Sans , sans-serif",
      fontSize: "14px",
      fontWeight: 700,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
    }),
  };

  console.log("activeuser", filter);

  const [affiliateData, setAffiliateData] = useState([]);
  const [search, setSearch] = useState(userData?.email || null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageNumbers, setPageNumbers] = useState([]);
  const [dateRange, setDateRange] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const [isSelectionMode, setIsSelectionMode] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [influencerLoading, setInfluencerLoading] = useState(false);
  const [ordering, setOrdering] = useState("");
  const [influencerFilter, setInfluencerFilter] = useState("all");
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();

  const fetch = async (email) => {
    dispatch(setIsLoading(true));
    const email1 = email ? userData?.email : search;
    const isInfParam =
      influencerFilter === "true"
        ? true
        : influencerFilter === "false"
        ? false
        : undefined;

    const response = await getAffiliateListV2(
      idToken,
      email1,
      currentPage,
      ordering,
      isInfParam
    );
    if (response?.status < 399) {
      let data = response?.data?.results || [];
      if (influencerFilter === "true") {
        data = data.filter((item) => item.is_influencer === true);
      } else if (influencerFilter === "false") {
        data = data.filter((item) => !item.is_influencer);
      }
      setAffiliateData(data);
      setTotalPages(Math.ceil((response?.data?.count || data.length) / 21));
    } else {
      let msg =
        response?.response?.data?.detail || "Error getting payment list";
      dispatch(returnErrors(msg, 400));
    }
    dispatch(setIsLoading(false));
  };

  const [searchValue, setSearchValue] = useState("");
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
  };

  const handleSelectRow = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const pageIds = affiliateData.map((item) => item.id).filter(Boolean);
      setSelectedIds((prev) => Array.from(new Set([...prev, ...pageIds])));
    } else {
      const pageIds = affiliateData.map((item) => item.id).filter(Boolean);
      setSelectedIds((prev) => prev.filter((id) => !pageIds.includes(id)));
    }
  };

  const handleFlagInfluencer = async (isInfluencer) => {
    if (!idToken) return;

    if (selectedIds.length === 0) {
      toast("Please select at least one affiliate.", {
        position: "top-right",
        autoClose: 2000,
        type: "warning",
        theme: "dark",
      });
      return;
    }

    setInfluencerLoading(true);
    try {
      const promises = selectedIds.map((id) =>
        flagInfluencer(idToken, {
          affiliate_id: id,
          is_influencer: isInfluencer,
        })
      );
      const responses = await Promise.all(promises);
      const allSuccess = responses.every((res) => res && res.status < 399);

      if (allSuccess) {
        toast(
          isInfluencer
            ? `Successfully added ${selectedIds.length} affiliate(s) to influencer!`
            : `Successfully removed ${selectedIds.length} affiliate(s) from influencer!`,
          {
            position: "top-right",
            autoClose: 2000,
            type: "success",
            theme: "dark",
          }
        );
        setSelectedIds([]);
        setIsSelectionMode(false);
        fetch();
      } else {
        toast("Some updates may have failed. Please check.", {
          position: "top-right",
          autoClose: 2000,
          type: "error",
          theme: "dark",
        });
        setSelectedIds([]);
        setIsSelectionMode(false);
        fetch();
      }
    } catch (error) {
      console.error("Error updating influencer flag:", error);
      toast("Error updating influencer status.", {
        position: "top-right",
        autoClose: 2000,
        type: "error",
        theme: "dark",
      });
    } finally {
      setInfluencerLoading(false);
    }
  };

  const handleExportCSV = async () => {
    if (!idToken) return;

    if (!dateRange || !dateRange[0] || !dateRange[1]) {
      toast("Please select a date range before exporting.", {
        position: "top-right",
        autoClose: 2000,
        type: "warning",
        theme: "dark",
      });
      return;
    }

    const start_date = dateRange[0].format("YYYY-MM-DD");
    const end_date = dateRange[1].format("YYYY-MM-DD");

    setExportLoading(true);
    try {
      const response = await getInfluencerReport(idToken, start_date, end_date);
      if (response && response.status < 399) {
        const filename = `influencer-report-${start_date}-to-${end_date}.csv`;
        downloadBlob(response.data, filename, "text/csv;charset=utf-8;");
        toast("CSV Exported successfully!", {
          position: "top-right",
          autoClose: 2000,
          type: "success",
          theme: "dark",
        });
      } else {
        toast("Failed to export CSV.", {
          position: "top-right",
          autoClose: 2000,
          type: "error",
          theme: "dark",
        });
      }
    } catch (error) {
      console.error("Error exporting CSV influencer reports:", error);
      toast("Failed to export CSV.", {
        position: "top-right",
        autoClose: 2000,
        type: "error",
        theme: "dark",
      });
    } finally {
      setExportLoading(false);
    }
  };

  console.log("currentPage", currentPage);

  useEffect(() => {
    fetch();
  }, [userData, currentPage, search, ordering, influencerFilter]);

  const isLoading = useSelector((state) => state.auth.isLoading);
  return (
    <div className="overview_table">
      {" "}
      <div className="mobileNavSelector" style={{ marginBottom: "20px" }}>
        {/* Add React Select for route navigation */}
        <Select
          options={routeOptions}
          value={currentRoute}
          onChange={handleRouteChange}
          isSearchable={false}
        />
      </div>
      <div className=" table_wrapper">
        <div className="table_header">
          <div className="header_left_section">
            <form
              className="search_container"
              onSubmit={(e) => {
                e.preventDefault();
                setSearch(searchValue);
                setCurrentPage(1);
              }}
            >
              <input
                type="text"
                placeholder="Search..."
                onChange={handleSearchChange}
              />
              <button type="submit">
                <div style={{ width: "20px", padding: "3px 10px 0 0" }}>
                  <SearchNew style={{ width: "100%" }} />
                </div>
              </button>
            </form>

            <AntSelect
              value={influencerFilter}
              onChange={(val) => {
                setInfluencerFilter(val);
                setCurrentPage(1);
              }}
              style={{
                width: "160px",
                height: "38px",
              }}
              options={[
                { value: "all", label: "All Affiliates" },
                { value: "true", label: "Influencers Only" },
                { value: "false", label: "Non-Influencers" },
              ]}
            />

            {!isSelectionMode ? (
              <Button
                onClick={() => setIsSelectionMode(true)}
                style={{
                  borderRadius: "6px",
                  height: "38px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#eaf0f8",
                  color: "#1890ff",
                  border: "none",
                  whiteSpace: "nowrap",
                }}
              >
                Select Account
              </Button>
            ) : (
              <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                <Button
                  type="primary"
                  loading={influencerLoading}
                  disabled={selectedIds.length === 0}
                  onClick={() => handleFlagInfluencer(true)}
                  style={{
                    borderRadius: "6px",
                    height: "38px",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: selectedIds.length > 0 ? "#36D66B" : undefined,
                    borderColor: selectedIds.length > 0 ? "#36D66B" : undefined,
                    color: "#fff",
                    whiteSpace: "nowrap",
                  }}
                >
                  Add to Influencer {selectedIds.length > 0 ? `(${selectedIds.length})` : ""}
                </Button>
                <Button
                  danger
                  loading={influencerLoading}
                  disabled={selectedIds.length === 0}
                  onClick={() => handleFlagInfluencer(false)}
                  style={{
                    borderRadius: "6px",
                    height: "38px",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Remove from Influencer {selectedIds.length > 0 ? `(${selectedIds.length})` : ""}
                </Button>
                <Button
                  onClick={() => {
                    setIsSelectionMode(false);
                    setSelectedIds([]);
                  }}
                  style={{
                    borderRadius: "6px",
                    height: "38px",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Cancel
                </Button>
              </div>
            )}
          </div>

          <div className="header_right_section">
            <span style={{ fontSize: "14px", fontWeight: "700", color: "#3e4247", whiteSpace: "nowrap" }}>Date Range:</span>
            <RangePicker
              onChange={(dates) => setDateRange(dates)}
              value={dateRange}
              style={{
                borderRadius: "8px",
                borderColor: "#d9d9d9",
                height: "38px",
              }}
            />
            <Button
              type="primary"
              loading={exportLoading}
              onClick={handleExportCSV}
              style={{
                borderRadius: "6px",
                height: "38px",
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
                backgroundColor: "#eaf0f8",
                color: "#1890ff",
                border: "none",
                whiteSpace: "nowrap",
              }}
            >
              Export CSV
            </Button>
          </div>
          {/* <div className="search">
            <div className="search_bar">
              <input
                type="text"
                className="search_input"
                placeholder="Search..."
              />
              <img className="search_icon" src={Search} alt="search icon" />
            </div>
            <img className="" src={CalenderIcon} alt="calender icon" />
          </div> */}
          {/* <Link to="/affiliate-marketing/create-codes">
            {" "}
            <div className="create_wrapper">
              <img className="create_icon" src={CreateIcon} alt="create" />
              <p>Create Affiliate Code</p>
            </div>{" "}
          </Link> */}
        </div>
        <div className="table_scroll_wrapper">
          <Table
            openModal={openModal}
            handleRowClick={handleRowClick}
            filter={filter}
            pageNumbers={pageNumbers}
            setPageNumbers={setPageNumbers}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
            affiliateData={affiliateData}
            selectedBrand={selectedBrand}
            isSelectionMode={isSelectionMode}
            selectedIds={selectedIds}
            handleSelectRow={handleSelectRow}
            handleSelectAll={handleSelectAll}
            ordering={ordering}
            setOrdering={setOrdering}
          />{" "}
        </div>
        <ModalPopup
          id={affiliateId}
          open={isModalOpen}
          onClose={closeModal}
          modalContent={modalContent}
          openModal={openModal}
          closeModal={closeModal}
          selectedBrand={selectedBrand}
        />
      </div>{" "}
    </div>
  );
}
const handleCopyToClipboard = (text) => {
  toast("Copied email", {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    type: "success",
    theme: "dark",
    className: "custom-toast-container",
  });
};
export default AffiliateTable;

const Table = ({
  openModal,
  handleRowClick,
  filter,
  pageNumbers,
  setPageNumbers,
  currentPage,
  setCurrentPage,
  totalPages,
  affiliateData,
  selectedBrand,
  isSelectionMode,
  selectedIds,
  handleSelectRow,
  handleSelectAll,
  ordering,
  setOrdering,
}) => {
  const [isChallengeDropdown, setChallengeDropdown] = useState(false);
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);

  const activeEmail = useSelector(
    (state) => state.account.accountList.activeEmail.email,
  );

  // setting total pages
  useEffect(() => {
    setPageNumbers([...Array(totalPages).keys()].map((i) => i + 1));
  }, [totalPages]);

  const handlePagination = async (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !event.target.classList.contains("column_header")
      ) {
        setChallengeDropdown(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const columns = React.useMemo(() => {
    const cols = [];

    if (isSelectionMode) {
      cols.push({
        Header: () => (
          <Checkbox
            checked={
              affiliateData?.length > 0 &&
              affiliateData.every((item) => selectedIds?.includes(item.id))
            }
            indeterminate={
              affiliateData?.some((item) => selectedIds?.includes(item.id)) &&
              !affiliateData?.every((item) => selectedIds?.includes(item.id))
            }
            onChange={handleSelectAll}
          />
        ),
        id: "selection",
        disableSortBy: true,
        Cell: ({ row }) => (
          <div onClick={(e) => e.stopPropagation()}>
            <Checkbox
              checked={selectedIds?.includes(row.original.id)}
              onChange={() => handleSelectRow(row.original.id)}
            />
          </div>
        ),
      });
    }

    cols.push(
      {
        Header: "ID",
        accessor: "id",
        disableSortBy: true,
        Cell: ({ row, value }) => (
          <div
            onClick={() => handleRowClick(row.original.id, row.original.email)}
          >
            {value}
          </div>
        ),
      },
      {
        Header: "Full Name",
        accessor: "fullname",
        disableSortBy: true,
        // Cell: ({ value }) => (
        //   <div className="column_one_wrapper">
        //     <div className="name_initial">{value[0]}</div>
        //     <div className="name_text">{value}</div>
        //   </div>
        // ),
        Cell: ({ row, value }) => (
          <div
            onClick={() => handleRowClick(row.original.id, row.original.email)}
          >
            {value
              ?.split(" ")
              .map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
              .join(" ")}
          </div>
        ),
      },
      {
        Header: "Email",
        accessor: "email",
        disableSortBy: true,
        Cell: ({ row, value }) => (
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <p
              onClick={() =>
                handleRowClick(row.original.id, row.original.email)
              }
              className="email_column"
            >
              {" "}
              {value
                ?.split(" ")
                .map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
                .join(" ")}
            </p>

            <CopyToClipboard onCopy={handleCopyToClipboard} text={value}>
              {/* <button> */}
              {/* <p
                className="table_copy_button"
                style={{
                  marginRight: "20px",
                  // backgroundColor: "#35d269",
                  cursor: "pointer",
                }}
                onClick={() => handleCopyToClipboard(row.original?.payment_id)}
              >
                <ContentCopyIcon sx={{fontSize: "20px", backgroundColor: "#35d269", color: "black"}} />
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="24" height="24" rx="12" fill="#FFF" />
                  <path
                    d="M17.886 12.574C18 12.2987 18 11.9487 18 11.25C18 10.5513 18 10.2013 17.886 9.926C17.8106 9.74395 17.7001 9.57854 17.5608 9.43922C17.4215 9.29989 17.256 9.18938 17.074 9.114C16.7987 9 16.4487 9 15.75 9H11.4C10.56 9 10.14 9 9.81933 9.16333C9.53684 9.30719 9.30719 9.53684 9.16333 9.81933C9 10.1393 9 10.5593 9 11.4V15.75C9 16.4487 9 16.7987 9.114 17.074C9.26667 17.4413 9.55867 17.734 9.926 17.886C10.2013 18 10.5513 18 11.25 18C11.9487 18 12.2987 18 12.574 17.886M17.886 12.574C17.8106 12.756 17.7001 12.9215 17.5608 13.0608C17.4215 13.2001 17.256 13.3106 17.074 13.386C16.7987 13.5 16.4487 13.5 15.75 13.5C15.0513 13.5 14.7013 13.5 14.426 13.614C14.244 13.6894 14.0785 13.7999 13.9392 13.9392C13.7999 14.0785 13.6894 14.244 13.614 14.426C13.5 14.7013 13.5 15.0513 13.5 15.75C13.5 16.4487 13.5 16.7987 13.386 17.074C13.3106 17.256 13.2001 17.4215 13.0608 17.5608C12.9215 17.7001 12.756 17.8106 12.574 17.886M17.886 12.574C17.5275 13.8107 16.8678 14.9391 15.9661 15.8582C15.0645 16.7774 13.9489 17.4585 12.7193 17.8407L12.574 17.886M15 9V8.4C15 7.56 15 7.14 14.8367 6.81933C14.693 6.53694 14.4636 6.3073 14.1813 6.16333C13.86 6 13.44 6 12.6 6H8.4C7.56 6 7.14 6 6.81933 6.16333C6.53684 6.30719 6.30719 6.53684 6.16333 6.81933C6 7.13933 6 7.55933 6 8.4V12.6C6 13.44 6 13.86 6.16333 14.1807C6.30733 14.4633 6.53667 14.6927 6.81933 14.8367C7.13933 15 7.56 15 8.40067 15H9"
                    stroke="#36D66B"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p> */}
              <p
                className="table_copy_button"
                style={{
                  marginRight: "20px",
                  cursor: "pointer",
                }}
              >
                {selectedBrand?.brand === "crypto_edge" ? (
                  <BrandCopyIcon />
                ) : (
                  <CopyIcon />
                )}
              </p>
              {/* </button> */}
            </CopyToClipboard>
          </div>
        ),
      },
      // {
      //   Header: "Tracking",
      //   accessor: "tracking",
      //   Cell: () => (
      //     <button className="tracking_btn">/mick-vitamixc-proftrading</button>
      //   ),
      // },
      {
        Header: "Influencer",
        accessor: "is_influencer",
        disableSortBy: true,
        Cell: ({ row, value }) => (
          <span
            style={{
              padding: "4px 10px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "600",
              backgroundColor: value ? "#e6f7ed" : "#f5f5f5",
              color: value ? "#1da54e" : "#8c8c8c",
              display: "inline-block",
            }}
          >
            {value ? "Yes" : "No"}
          </span>
        ),
      },
      {
        Header: "Referred Count",
        accessor: "referred_count",
        Cell: ({ row, value }) => (
          <div
            onClick={() => handleRowClick(row.original.id, row.original.email)}
          >
            {value}
          </div>
        ),
      },
      {
        Header: "Sales (Count)",
        accessor: "sales_count",
        disableSortBy: true,
        disableFilters: true,
        Cell: ({ row, value }) => (
          <div
            onClick={() => handleRowClick(row.original.id, row.original.email)}
          >
            {value ?? 0}
          </div>
        ),
      },
      {
        Header: "Sales ($)",
        accessor: "sales_amount",
        disableSortBy: true,
        disableFilters: true,
        Cell: ({ row, value }) => (
          <div
            onClick={() => handleRowClick(row.original.id, row.original.email)}
          >
            {formatCurrency(Number(value || 0))}
          </div>
        ),
      },
      {
        Header: "Total Commissions Earned",
        accessor: "commission_payment",
        Cell: ({ row, value }) => (
          <div
            onClick={() => handleRowClick(row.original.id, row.original.email)}
          >
            {formatCurrency(
              Number(value ?? row.original.total_commissions_earned ?? 0)
            )}
          </div>
        ),
      },
      {
        Header: "Commissions Paid",
        accessor: "commissions_paid",
        disableSortBy: true,
        disableFilters: true,
        Cell: ({ row, value }) => (
          <div
            onClick={() => handleRowClick(row.original.id, row.original.email)}
          >
            {formatCurrency(Number(value || 0))}
          </div>
        ),
      },
      {
        Header: "Commissions Payable",
        accessor: "commissions_payable",
        disableSortBy: true,
        disableFilters: true,
        Cell: ({ row, value }) => (
          <div
            onClick={() => handleRowClick(row.original.id, row.original.email)}
          >
            {formatCurrency(Number(value || 0))}
          </div>
        ),
      },
      {
        Header: "Details",
        accessor: "referredList",
        disableSortBy: true,
        Cell: ({ row }) => (
          <button
            onClick={() => handleRowClick(row.original.id, row.original.email)}
            className="view_details_btn"
          >
            View Details
          </button>
        ),
      },
    );

    return cols;
  }, [
    isSelectionMode,
    affiliateData,
    selectedIds,
    handleSelectAll,
    handleSelectRow,
    selectedBrand,
  ]);
  let dummydata = [];
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { sortBy },
  } = useTable(
    {
      columns,
      data: affiliateData,
      manualSortBy: true,
      autoResetSortBy: false,
    },
    useSortBy,
  );

  useEffect(() => {
    if (sortBy && sortBy.length > 0) {
      const sort = sortBy[0];
      const newOrdering = sort.desc ? `-${sort.id}` : sort.id;
      if (newOrdering !== ordering) {
        setOrdering(newOrdering);
        setCurrentPage(1);
      }
    } else if (ordering !== "") {
      setOrdering("");
      setCurrentPage(1);
    }
  }, [sortBy]);

  const handleChange = (event, value) => {
    setCurrentPage(value);
  };

  const [gotoPageInput, setGotoPageInput] = useState();

  const handleGotoPage = () => {
    const pageNumber = parseInt(gotoPageInput, 10);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      setGotoPageInput("");
    }
  };
  return (
    <div className="table_scroll">
      <table {...getTableProps()} className="leaderboard-table">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={{
                    cursor: column.canSort ? "pointer" : "default",
                  }}
                >
                  <span>{column.render("Header")}</span>
                  {column.canSort && (
                    <span style={{ marginLeft: 6 }}>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? "▼"
                          : "▲"
                        : "↕"}
                    </span>
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        {/* <h2 style={{ marginLeft: "auto" }}>
          {affiliateData.length === 0 && "No Affiliate Data"}
        </h2> */}
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>
                    {cell.column.Header === "Referred List" ? (
                      <button
                        className="view_details_btn"
                        // onClick={() => openModal(row.original.id)}
                        onClick={() =>
                          handleRowClick(row.original.id, row.original.email)
                        }
                      >
                        View Details
                      </button>
                    ) : (
                      cell.render("Cell")
                    )}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* <div className="pagination">
        <img src={CaretLeftIcon} alt="" />
        <button
          style={{ color: `${currentPage === 1 ? "#a8a8a8" : "black"}` }}
          onClick={() => {
            if (currentPage === 1) {
              return;
            } else {
              handlePagination(currentPage - 1);
            }
          }}
        >
          Previous
        </button>
        <span style={{ display: "flex", gap: "15px", fontWeight: "100" }}>
          {pageNumbers.map((pageNumber, idx) => (
            <strong key={pageNumber}>
              {currentPage === pageNumber ? (
                <span
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    fontWeight: "900",
                  }}
                >
                  {pageNumber}
                </span>
              ) : (
                <div
                  onClick={() => {
                    handlePagination(pageNumber);
                  }}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    fontWeight: "20",
                    padding: "4px",
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    cursor: "pointer",
                  }}
                >
                  {pageNumber}
                </div>
              )}
            </strong>
          ))}
        </span>
        <button
          style={{
            color: `${currentPage + 1 > totalPages ? "#a8a8a8" : "black"}`,
          }}
          onClick={() => {
            if (currentPage + 1 > totalPages) {
              return;
            } else {
              handlePagination(currentPage + 1);
            }
          }}
        >
          Next
        </button>
        <img src={CaretRightIcon} alt="" />
      </div> */}
      <div className="spacerT30p"></div>
      <div
        className="pagination_wrapper"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "20px 0px",
        }}
      >
        <Pagination
          onChange={handleChange}
          count={totalPages}
          variant="outlined"
          page={currentPage}
          color="primary"
        />
        <div className="goto-page-input">
          <input
            type="number"
            placeholder="Go to Page"
            value={gotoPageInput}
            onChange={(e) => setGotoPageInput(e.target.value)}
          />
          <button className="goToButton" onClick={handleGotoPage}>
            Go
          </button>
        </div>
      </div>
    </div>
  );
};

export const ModalPopup = ({ open, onClose, id, selectedBrand }) => {
  const [referredList, setReferredList] = useState([]);
  const idToken = useSelector((state) => state.auth.idToken);
  const [isLoadingComponents, setisLoadingComponents] = useState(true);

  const data = async () => {
    if (open === true) {
      const data = await traderAffiliateRefList(idToken, id);
      setReferredList(data);
      setisLoadingComponents(false);
    }
  };
  useEffect(() => {
    data();
  }, [open]);

  const handleClose = () => {
    onClose();
    setisLoadingComponents(true);
  };

  return (
    <div className="modalDiv_">
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modal"
      >
        <Box
          className="modal-content"
          style={{
            border: "1px solid var(--secondary-color)",
            padding: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 0",
            }}
          >
            <p
              style={{
                margin: "0",
                fontSize: "25px ",
                textAlign: "center",
                width: "100%",
                fontWeight: "800",
                color:
                  selectedBrand?.brand === "crypto_edge"
                    ? "#fcd535"
                    : "var(--seco ndary-color)",
              }}
            >
              Referred List
            </p>
            <p
              onClick={handleClose}
              className="ptag"
              style={{
                cursor: "pointer",
                margin: "0",
                fontWeight: "600",
                fontSize: "22px",
              }}
            >
              X
            </p>
          </div>

          <div className="reffered_list_loaders">
            {isLoadingComponents ? <CircularProgress /> : ""}
          </div>
          <div>
            {!isLoadingComponents ? (
              <ul style={{ padding: "0" }}>
                {referredList.length > 0 ? (
                  referredList.map((user, idx) => {
                    return (
                      <li
                        style={{
                          listStyle: "none",
                          display: "flex",
                          gap: "10px",
                          color: "var(--text-color)",
                        }}
                      >
                        <div style={{ fontSize: "18px", color: "#80e0c4" }}>
                          {idx + 1} .
                        </div>
                        <div style={{ fontSize: "18px" }}>{user.email}</div>
                      </li>
                    );
                  })
                ) : (
                  <p
                    style={{ fontSize: "18px", color: "var(--text-color)" }}
                    className="no_reffered_user"
                  >
                    No Reffered Users
                  </p>
                )}
              </ul>
            ) : (
              ""
            )}
          </div>
        </Box>
      </Modal>
    </div>
  );
};
